import { useCallback, useEffect, useRef } from "react";

/** Ignore backdrop dismiss briefly after open (mobile ghost-click after opening). */
const BACKDROP_GUARD_MS = 400;

export function useBackdropDismissGuard(isOpen: boolean) {
  const guardUntilRef = useRef(0);

  useEffect(() => {
    if (isOpen) {
      guardUntilRef.current = Date.now() + BACKDROP_GUARD_MS;
    }
  }, [isOpen]);

  return useCallback((onDismiss: () => void) => {
    if (Date.now() < guardUntilRef.current) {
      return;
    }
    onDismiss();
  }, []);
}
